module.exports = __webpack_public_path__ + "static/media/Naydalis P.c2162593.png";